(() => {
	const AJAX_URL = custom_cart_object.ajaxurl;
	const NONCE = custom_cart_object.nonce;

	const cartMenuItem = document.querySelector('#meta-menu .cart');
	const cartCountElement = document.querySelector('[data-cartcount]');
	const cartCountHeadingElement = document.querySelector('.cart-heading [data-count]');
	let cartCount = cartCountElement ? cartCountElement.dataset.cartcount : 0;

	function updateMenuItem() {
		if (cartMenuItem) {
			if (cartCount >= 100) cartCount = 99;
			cartMenuItem.querySelector('a').textContent = cartCount;
		}
		if (cartCountElement) cartCountElement.dataset.cartcount = cartCount;
		if (cartCountHeadingElement) cartCountHeadingElement.innerHTML = cartCount;
	}
	updateMenuItem();

	// Single Product
	if (document.querySelector('.single-product')) {
		(() => {
			const submitButton = document.querySelector('[name=add-to-cart]');

			const productIdElement = document.querySelector('[data-productid]');
			const messageInCart = document.querySelector('[data-messageincart]');

			const quantityInput = document.querySelector('[name=quantity]');
			const runtimeInput = document.querySelector('[name=runtime]');
			let qty = quantityInput ? quantityInput.value : 0;
			let runtime = runtimeInput ? runtimeInput.value : 0;

			const priceElement = document.querySelector('[data-price]');
			const originalPrice = priceElement ? parseFloat(priceElement.dataset.price) : -1;
			const factorTwo = priceElement ? parseFloat(priceElement.dataset.factortwo) : -1;
			const factorThree = priceElement ? parseFloat(priceElement.dataset.factorthree) : -1;
			const factorFive = priceElement ? parseFloat(priceElement.dataset.factorfive) : -1;
			const taxrate = priceElement ? parseFloat(priceElement.dataset.taxrate) : -1;

			const multiplicator = {
				1: 1,
				2: factorTwo,
				3: factorThree,
				5: factorFive,
			};

			const AJAX_URL_CART = '?wc-ajax=add_to_cart';

			function updatePrice(e) {
				if (e) {
					if (e.target.name === 'quantity') qty = e.target.value;
					if (e.target.name === 'runtime') runtime = e.target.value;
				}
				let price = originalPrice * qty * multiplicator[runtime] * taxrate;
				if (document.documentElement.lang === 'de')
					price = Intl.NumberFormat('de-DE', {
						minimumFractionDigits: 2,
						maximumFractionDigits: 2,
					}).format(price);
				else
					price = Intl.NumberFormat('en-GB', {
						minimumFractionDigits: 2,
						maximumFractionDigits: 2,
					}).format(price);
				if (document.querySelector('[data-price]'))
					document.querySelector('[data-price] ~ .amount bdi').firstChild.nodeValue = price;
				if (document.querySelector('[data-title="Price"]'))
					document.querySelector('[data-title="Price"] .amount bdi').firstChild.nodeValue = price;
			}

			function updateButton() {
				if (submitButton) {
					if (messageInCart) submitButton.textContent = messageInCart.textContent;
					submitButton.disabled = true;
				}
			}

			function submitToCart(e) {
				e.preventDefault();
				const url = `${window.location}${AJAX_URL_CART}`;
				const formData = new FormData();
				formData.append('action', 'woocommerce_ajax_add_to_cart');
				formData.append('product_id', productIdElement.value);
				if (runtimeInput) formData.append('runtime', runtimeInput.value);
				formData.append('quantity', quantityInput.value);
				fetch(url, {
					method: 'POST',
					body: formData,
				})
					.then(response => {
						if (response.status === 200) {
							cartCount++;
							updateMenuItem();
							updateButton();
						}
					})
					.catch(error => {
						console.error('Error:', error);
					});
			}

			if (quantityInput) quantityInput.addEventListener('input', updatePrice);
			if (runtimeInput) runtimeInput.addEventListener('input', updatePrice);
			if (submitButton) submitButton.addEventListener('click', submitToCart);
			updateMenuItem();
		})();
	}

	// Cart
	if (document.querySelector('.woocommerce-cart-form')) {
		(() => {
			const cartItems = document.querySelectorAll('.cart_item');
			const collateralSubtotal = document.querySelector('.cart_totals .cart-subtotal td');
			const collateralTax = document.querySelector('.cart_totals .tax-rate td');
			const collateralTotal = document.querySelector('.cart_totals .order-total td');

			function updatePrice(data) {
				Object.entries(data).forEach(([key, value]) => {
					const hiddenProductElement = document.querySelector(`[data-productid="${key}"]`);
					if (hiddenProductElement) {
						const productItem = hiddenProductElement.closest('.cart_item');
						if (value === 'removed') {
							productItem.remove();
							cartCount--;
							updateMenuItem();
						} else {
							const priceElement = productItem.querySelector('[data-title="Price"]');
							const [price] = Object.keys(value);
							priceElement.innerHTML = price;
							const subtotalElement = productItem.querySelector('[data-title="Subtotal"]');
							const [subtotal] = Object.values(value);
							const label = subtotalElement.querySelector('.price-vat');
							subtotalElement.innerHTML = subtotal;
							if (label) subtotalElement.appendChild(label);
						}
					}
				});
				collateralSubtotal.innerHTML = data.subtotal;
				if (collateralTax) collateralTax.innerHTML = data.taxes;
				collateralTotal.innerHTML = data.total;
			}

			function submitCart(id, runtime, quantity) {
				fetch(AJAX_URL, {
					method: 'POST',
					credentials: 'same-origin',
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded',
						'Cache-Control': 'no-cache',
					},
					body: new URLSearchParams({
						action: 'custom_ajax_cart',
						nonce: NONCE,
						product_id: id,
						runtime,
						quantity,
					}),
				})
					.then(response => response.json())
					.then(data => {
						updatePrice(data);
					})
					.catch(error => {
						console.error('Error:', error);
					});
			}

			function updateCart(e) {
				e.preventDefault();
				const productItem = e.target.closest('.cart_item');
				const productId = productItem.querySelector('[data-productid]').dataset.productid;
				const runtimeInput = productItem.querySelector('[name="runtime"]').value;
				const quantityInput = productItem.querySelector('[data-title="Quantity"] select').value;
				submitCart(productId, runtimeInput, quantityInput);
			}

			cartItems.forEach(item => {
				const runtimeInput = item.querySelector('[name="runtime"]');
				runtimeInput.addEventListener('input', updateCart);
				const quantityInput = item.querySelector('[data-title="Quantity"] select');
				quantityInput.addEventListener('input', updateCart);
			});

			document.querySelectorAll('.product-remove .remove').forEach(link =>
				link.addEventListener('click', () => {
					cartCount--;
					updateMenuItem();
				})
			);
		})();
	}

	// Checkout and Account Edit Address
	if (
		document.querySelector('.woocommerce-address-fields__field-wrapper') ||
		document.querySelector('.woocommerce-checkout')
	) {
		(() => {
			const commercialRadio = document.getElementById('billing_commercial_commercial');
			const privateRadio = document.getElementById('billing_commercial_private');
			const companyField = document.getElementById('billing_company_field');
			const commercialTaxField = document.getElementById('billing_commercial_tax_field');
			const companyInput = document.getElementById('billing_company');

			const requiredNode = document.createElement('abbr');
			requiredNode.classList.add('required');
			requiredNode.title = 'required';
			requiredNode.innerHTML = '*';

			const optionalNode = document.createElement('span');
			optionalNode.classList.add('optional');
			optionalNode.innerHTML = '(optional)';

			commercialRadio.addEventListener('click', () => {
				if (commercialRadio.checked) {
					companyInput.required = true;
					companyField.querySelector('.optional').replaceWith(requiredNode);
					// companyField.replaceChild(companyField.querySelector('.optional'), requiredNode);
					companyField.classList.remove('hidden');
					commercialTaxField.classList.remove('hidden');
				} else {
					companyInput.required = false;
					companyField.querySelector('.required').replaceWith(optionalNode);
					// companyField.replaceChild(companyField.querySelector('.required'), optionalNode);
					companyField.classList.add('hidden');
					commercialTaxField.classList.add('hidden');
				}
			});
			if (commercialRadio.checked) commercialRadio.click();
			privateRadio.addEventListener('click', () => {
				if (commercialRadio.checked) {
					companyInput.required = true;
					companyField.querySelector('.optional').replaceWith(requiredNode);
					// companyField.replaceChild(companyField.querySelector('.optional'), requiredNode);
					companyField.classList.remove('hidden');
					commercialTaxField.classList.remove('hidden');
				} else {
					companyInput.required = false;
					companyField.querySelector('.required').replaceWith(optionalNode);
					// companyField.replaceChild(companyField.querySelector('.required'), optionalNode);
					companyField.classList.add('hidden');
					commercialTaxField.classList.add('hidden');
				}
			});
			if (privateRadio.checked) privateRadio.click();
		})();
	}
})();
